export const LARGE_NEW_VERSION = "largenew-v1";
export const LARGE_NEW_STEPS = [
  "welcome", "david", "david-explained", "samaritan", "samaritan-explained",
  "sheep", "sheep-explained", "how-it-works", "goal", "your-goal",
  "obstacle", "a-smaller-start", "format", "your-format", "routine", "your-routine",
  "hesitation", "room-to-begin", "preview", "courage", "grace", "kindness",
  "start", "your-plan", "email", "plans", "checkout",
] as const;
export type LargeNewStepId = typeof LARGE_NEW_STEPS[number];
export const isLargeNewPath = (path: string) => /^\/largenew(?:\/|$)/.test(path);
export function largeNewStepFromPath(path: string): LargeNewStepId | null {
  const match = /^\/largenew(?:\/([a-z-]+))?\/?$/.exec(path);
  if (!match) return null;
  return match[1] === undefined ? "welcome" : LARGE_NEW_STEPS.find(id => id === match[1]) ?? null;
}
export function safeLargeNewPath(path: string): string | null {
  return largeNewStepFromPath(path) ? path.replace(/\/$/, "") : null;
}
export function largeNewUrl(href: string, step: LargeNewStepId): string {
  const url = new URL(href);
  url.pathname = step === "welcome" ? "/largenew/" : `/largenew/${step}/`;
  url.hash = "";
  for (const key of ["step", "email", "promo", "promo_code", "subscription_id", "session_id", "payment_intent", "payment_intent_client_secret", "redirect_status"]) url.searchParams.delete(key);
  return url.href;
}
